import React, { useState, useEffect } from "react";
import { Button, Card, Image, message } from "antd";
import {
  CheckCircleFilled,
  EditOutlined,
  FileImageOutlined,
} from "@ant-design/icons";
import axios from "axios";
import SignatureModal from "./SignatureModal";

export default function SignatureItem({ title, verificacionId, nombreFormato }) {
  const [signature, setSignature] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [signatureImage, setSignatureImage] = useState(null);

  useEffect(() => {
    const fetchSignature = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/firmas/${verificacionId}`);
        const existingSignature = response.data.find(
          (sig) => sig.NombreFormato === nombreFormato
        );
        if (existingSignature) {
          setSignatureImage(existingSignature.Ruta);
        }
      } catch (error) {
        console.error("Error fetching signature:", error);
        message.error("Failed to fetch existing signature.");
      } finally {
        setLoading(false);
      }
    };

    fetchSignature();
  }, [verificacionId, nombreFormato]);

  const handleUpload = () => {
    message.info("Upload functionality not implemented yet.");
  };

  const handleDraw = () => {
    setIsModalVisible(true);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const handleSaveSignature = async (dataURL, verifId, formName) => {
    setSignatureImage(dataURL);
    setIsModalVisible(false);

    // Convert dataURL to Blob
    const blob = await (await fetch(dataURL)).blob();
    const file = new File([blob], `${verifId}_${formName}_${new Date().getTime()}.png`, { type: "image/png" });

    const formData = new FormData();
    formData.append("signature", file);
    formData.append("verificacionid", verifId);
    formData.append("plantilla", formName);
    formData.append("UsuarioID", 1); // Placeholder for actual UserID

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/firmas`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      message.success("Signature uploaded successfully!");
      // Optionally, refetch signatures or update state to show the new signature
      // setSignature(dataURL); // Assuming dataURL can be directly used to display
    } catch (error) {
      console.error("Error uploading signature:", error);
      message.error("Failed to upload signature.");
    }
  };

  return (
    <>
      <Card
        hoverable
        title={title}
        size="small"
        actions={[
          <Button
            key="upload"
            icon={<FileImageOutlined style={{ fontSize: "20px" }} />}
            onClick={handleUpload}
            disabled={!!signatureImage}
            type="text"
            style={{ width: "100%" }}
          >
            Cargar
          </Button>,
          <Button
            key="draw"
            icon={<FileImageOutlined style={{ fontSize: "20px" }} />}
            onClick={handleDraw}
            disabled={!!signatureImage}
            type="text"
            style={{ width: "100%" }}
          >
            Dibujar
          </Button>,
        ]}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "75px",
            width: "100%",
            padding: "1rem",
          }}
        >
          {signatureImage ? (
            <Image width={150} src={signatureImage} />
          ) : (
            <EditOutlined style={{ color: "#ccc", fontSize: "24px" }} />
          )}
        </div>
      </Card>

      <SignatureModal
        visible={isModalVisible}
        onCancel={handleModalCancel}
        onSave={handleSaveSignature}
        verificacionId={verificacionId}
        nombreFormato={nombreFormato}
      />
    </>
  );
}
